import { useState } from "react";

const DocumentationContainer = () => {
  const [state, setState] = useState({
    src: process.env.REACT_APP_MANUAL,
    height: window.innerHeight,
    width: window.innerWidth,
  });
  return (
    <div>
      <iframe
        src={state.src}
        height={state.height}
        width={state.width}
      />
    </div>
  );
};
export default DocumentationContainer;
